import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { create } from "zustand";
import { persist } from "zustand/middleware";

const MAX = 5;

interface RecentState {
	ids: string[];
	visit: (id: string) => void;
}

/** The last few node pages visited, newest first (this browser only). */
export const useRecent = create<RecentState>()(
	persist(
		(set) => ({
			ids: [],
			visit: (id) => set((s) => ({ ids: [id, ...s.ids.filter((x) => x !== id)].slice(0, MAX + 3) })),
		}),
		{ name: "modelcurve:recent" },
	),
);

export const RECENT_SHOWN = MAX;

/** Records each /node/:id the router lands on. */
export function useTrackRecent() {
	const { pathname } = useLocation();
	useEffect(() => {
		const m = matchPath("/node/:nodeId", pathname);
		if (m?.params.nodeId) useRecent.getState().visit(m.params.nodeId);
	}, [pathname]);
}
